import React, { useState, useEffect } from "react";
import {
  Card, Row, Col, Typography, Space, message, Input, Select, Button,
  Empty, Slider, Radio, Rate
} from "antd";
import { useNavigate, useParams } from "react-router-dom";
import style from '../../Styles/AddUser.module.css';
import { FaArrowLeft } from "react-icons/fa";
import { QuestionBank } from "../../Api/QuestionBankApi";
import SurveyCategoryApi from "../../Api/SurveyCategoryApi";
import { FiEdit } from "react-icons/fi";

const { Title, Text } = Typography;
const { Option } = Select;

const PreviewQuestionBank = () => {
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState([]);
  const [selectedCat, setSelectedCat] = useState(null);
  const [hoveredId, setHoveredId] = useState(null);
const { id: questionId, categoryId } = useParams();
  const navigate = useNavigate();
  


  const PRIMARY_BLUE = '#003a8c';

useEffect(() => {
  fetchCategories();

  if (questionId) {
    loadQuestionData(questionId);
  }

  if (categoryId) {
    setSelectedCat(Number(categoryId)); 
  }

}, [questionId, categoryId]);

  const fetchCategories = async () => {
    try {
      const res = await SurveyCategoryApi.getDropdown();
      if (res?.data?.success) setCategories(res.data.result);
    } catch (err) {
      message.error("Failed to load categories");
    }
  };

const loadQuestionData = async (questionId) => {
  setLoading(true);

  try {
    const payload = {
      id: questionId  
    };

    const res = await QuestionBank.getQuestionsList(payload);

    if (res?.data?.success) {
      const resData = res.data.result;

      const qs = Array.isArray(resData)
        ? resData
        : resData
        ? [resData]
        : [];

      setQuestions(qs);
    }

  } catch (err) {
    console.error(err);
    message.error("Failed to load questions");
  } finally {
    setLoading(false);
  }
};
  const parseData = (data) => {
    if (!data) return null;
    try {
      return typeof data === "string" ? JSON.parse(data) : data;
    } catch (e) { return null; }
  };

  const renderQuestionContent = (q) => {
    const type = (q.question_type || "").toLowerCase();
    const options = parseData(q.option);
    
    // --- 1. Matrix Question View ---
    if (type === "matrix") {
        const rows = options?.rows || [q.question || q.title];
        const columns = options?.columns || ["Strongly Disagree", "Disagree", "Neutral", "Agree", "Strongly Agree"];
  
        return (
          <div style={{ marginTop: 15, overflowX: 'auto', border: '1px solid #f0f0f0', borderRadius: '4px' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', backgroundColor: '#fff' }}>
              <thead>
                <tr style={{ backgroundColor: '#fafafa' }}>
                  <th style={{ width: '250px', borderBottom: '1px solid #f0f0f0', padding: '12px' }}></th>
                  {columns.map((col, i) => (
                    <th key={i} style={{ padding: '10px', textAlign: 'center', color: '#8c8c8c', fontWeight: '500', borderBottom: '1px solid #f0f0f0' }}>
                      {typeof col === 'object' ? col.title : col}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {rows.map((rowItem, rowIdx) => (
                  <tr key={rowIdx} style={{ borderBottom: '1px solid #f0f0f0' }}>
                    <td style={{ padding: '12px 15px', fontWeight: '500', color: '#595959' }}>
                      {rowItem?.title || rowItem?.question || rowItem}
                    </td>
                    {columns.map((_, colIdx) => (
                      <td key={colIdx} style={{ textAlign: 'center' }}>
                        <Radio disabled />
                       </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        );
      }

    // --- 2. Slider Question View ---
    if (type === "slider") {
      const sliderSettings = Array.isArray(options) ? options[0] : (options || {});
      const minVal = sliderSettings?.min ?? 0;
      const maxVal = sliderSettings?.max ?? 100;

      return (
        <div style={{ marginTop: 20, padding: '0 10px' }}>
          <Slider 
            disabled 
            value={maxVal / 2} 
            min={minVal}
            max={maxVal}
            trackStyle={{ backgroundColor: '#003a8c' }} 
            handleStyle={{ borderColor: '#00d09c', backgroundColor: '#fff' }} 
          />
          <div style={{ display: 'flex', justifyContent: 'space-between', color: '#8c8c8c', fontSize: '12px' }}>
            <span>{minVal}</span>
            <span>{maxVal}</span>
          </div>
        </div>
      );
    }

    // --- 3. Rating Question View ---
    if (type === "rating") {
      const ratingSettings = Array.isArray(options) ? options[0] : options;
      const ratingValue = ratingSettings?.title ? Number(ratingSettings.title) : 5;
      
      return (
        <div style={{ marginTop: 20 }}>
          <div style={{ 
            background: '#f0f0f0', 
            padding: '16px', 
            borderRadius: '8px',
            border: '1px solid #f0f0f0'
          }}>
            <Text style={{ color: '#6c757d', fontSize: '13px', display: 'block', marginBottom: '12px' }}>
              Rating Scale (1 – {ratingValue})
            </Text>
            <Rate disabled value={ratingValue} count={ratingValue} style={{ fontSize: 20 }} />
          
          </div>
        </div>
      );
    }

    // --- 4. Radio/Checkbox View ---
    if (type === "radio" || type === "checkbox") {
      const optList = Array.isArray(options) ? options : [];
      return (
        <Space direction="vertical" style={{ width: '100%', marginTop: 20 }} size={12}>
          {optList.map((opt, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
              <div style={{ 
                width: '18px', height: '18px', 
                borderRadius: type === 'radio' ? '50%' : '2px', 
                border: '1px solid #ced4da', backgroundColor: '#fff'
              }} />
              <Text style={{ color: '#495057', fontSize: '15px' }}>
                {opt?.title || opt?.label || (typeof opt === 'string' ? opt : '')}
              </Text>
            </div>
          ))}
        </Space>
      );
    }

    // --- 5. Text View ---
    if (type === "text") {
      return <Input.TextArea disabled rows={2} placeholder="User response text area..." style={{ marginTop: 20, borderRadius: '2px', backgroundColor: '#' }} />;
    }

    return null;
  };

  const renderQuestion = (q, idx) => {
    const isHovered = hoveredId === q.id;

    return (
      <Card 
        key={q.id} 
        bodyStyle={{ padding: '20px 24px' }}
        onMouseEnter={() => setHoveredId(q.id)}
        onMouseLeave={() => setHoveredId(null)}
        // style={{ 
        //   marginBottom: 15, 
        //   border: isHovered ? `1px solid ${PRIMARY_BLUE}` : '1px solid #f0f0f0',
        //   transition: 'all 0.3s ease',
        //   position: 'relative',
        //   backgroundColor: '#fff',
        //   boxShadow: isHovered ? '0 4px 12px rgba(0,0,0,0.05)' : 'none'
        // }}
      >
        <Row gutter={[16, 0]} align="top" wrap={false}>
          <Col flex="auto">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
              <Text style={{ fontSize: "16px", color: "#fff'", fontWeight: '500', display: 'block' }}>
                {idx + 1}. {q.question || q.title} {(q.is_required === true || q.is_required === 1 || q.is_required === "true") && (
                  <span style={{ color: '#ff4d4f' }}> *</span>
                )}
              </Text>
            </div>
            
            {renderQuestionContent(q)}

            {/* Hover Edit Button - Uncomment if needed */}
            {/* <div style={{ 
              marginTop: '15px', 
              display: 'flex', 
              justifyContent: 'flex-end',
              opacity: isHovered ? 1 : 0,
              visibility: isHovered ? 'visible' : 'hidden',
              transition: 'opacity 0.3s ease'
            }}>
              <Space>
                <Button 
                  size="small"
                  onClick={() => navigate(`/add-question/${q.id}/${selectedCat}`, { state: { oldData: q } })}
                  style={{ backgroundColor: '#94a3b8', color: '#fff', border: 'none', borderRadius: '4px' }}
                >
                  Edit
                </Button>
              </Space>
            </div> */}
          </Col>
        </Row>
      </Card>
    );
  };

  return (
    <div style={{ minHeight: "100vh" }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        
        <div
          className={`${style['arrow-icon']} border px-2 pb-1`}
          onClick={() => navigate(-1)}
          style={{ cursor: 'pointer' }}
        >
          <FaArrowLeft />
        </div>
        <div  className={`${style['add-user']} mx-1 mb-0`} style={{ fontSize: '18px', fontWeight: 600 }}>
          Preview Question
        </div>
      </div>

      <div style={{ padding: '15px 30px' }}>
        <Row align="middle" justify="space-between">
          <Col>
            <Row align="middle" gutter={10}>
              <Col><Text style={{ color: '#6c757d', fontWeight: '500' }}>Category:</Text></Col>
              <Col>
                <Select
                  style={{ width: 250 }}
                  placeholder="Select Category"
                  value={selectedCat}
                  disabled={true}
                  onChange={(val) => {
                    setSelectedCat(val);
                    loadQuestionData(val);
                  }}
                >
                  {categories.map(cat => (
                    <Option key={cat.id} value={cat.id}>{cat.categoryName}</Option>
                  ))}
                </Select>
              </Col>
            </Row>
          </Col>

          {/* Edit Button at Top Right */}
          <Col>
            <div
              title="Edit Category Questions"
              onClick={() => {
                if (!selectedCat) {
                  message.error("Select category first");
                  return;
                }
                if (questions.length === 0) {
                  navigate(`/add-question/0/${selectedCat}`);
                  return;
                }
                const firstQuestion = questions[0];
                navigate(`/add-question/${firstQuestion.id}/${selectedCat}`, { 
                  state: { oldData: firstQuestion } 
                });
              }}
              style={{
                marginLeft: 'auto',
                display: 'flex',
                alignItems: 'center',
                cursor: 'pointer',
                color: '#333',
                padding: '6px 10px',
                borderRadius: '4px',
                border: '1px solid #ccc',
                background: '#fafafa',
                transition: 'background 0.3s'
              }}
              onMouseEnter={(e) => (e.currentTarget.style.background = '#f0f0f0')}
              onMouseLeave={(e) => (e.currentTarget.style.background = '#fafafa')}
            >
              <FiEdit size={16} />
              <span style={{ marginLeft: 6, fontSize: 14, fontWeight: 500 }}>
                Edit
              </span>
            </div>
          </Col>
        </Row>
      </div>

      <div style={{ padding: '0 30px 40px 30px' }}>
        {loading ? (
          <div style={{ textAlign: 'center', padding: '100px 0' }}>
            {/* <Text type="secondary">Fetching questions...</Text> */}
          </div>
        ) : (
          questions.length > 0 ? (
            questions.map((q, idx) => renderQuestion(q, idx))
          ) : (
            <Card>
              <Empty description="No questions found for this category">
                <Button 
                  type="primary" 
                  onClick={() => navigate(`/add-question/0/${selectedCat}`)}
                  style={{ background: PRIMARY_BLUE }}
                >
                  Add Question
                </Button>
              </Empty>
            </Card>
          )
        )}
      </div>
    </div>
  );
};

export default PreviewQuestionBank;